import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

export const LoaderWrapper = styled('div', { label: 'LoaderWrapper' })`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: ${mainColors.default.light};
    opacity: 0.7;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
`;
    
export const SpinnerWrapper = styled('img', { label: 'SpinnerWrapper' })`
    display: block;
    width: 50px;
`;
    
